// Design tokens shared across modernized pages. When a token needs to
// change (brand color, spacing scale, etc.), change it here — pages that
// import from ./ui pick it up automatically.

export const COLOR = {
  ink: '#111827',        // Primary text
  muted: '#6b7280',      // Secondary / subtitle text
  rule: '#e5e7eb',       // Borders / separators
  surface: '#ffffff',    // Card background
  page: '#ffffff',       // Page background
  subtle: '#fafafa',     // Card header / hover
  brand: '#dc3545',      // LSSI red
  brandDark: '#b02a37',
  brandTint: '#eef2ff',  // Chip background (info)
  brandInk: '#3730a3',   // Chip text (info)
  successBg: '#dcfce7',
  successInk: '#166534',
  warnBg: '#fef3c7',
  warnInk: '#92400e',
  dangerBg: '#fee2e2',
  dangerInk: '#b91c1c',
};

export const FONT =
  '-apple-system, "Segoe UI", "Helvetica Neue", Arial, sans-serif';

export const MONO =
  'ui-monospace, "SF Mono", Menlo, monospace';

export const RADIUS = {
  sm: 6,
  md: 8,
  lg: 12,
};

export const SHADOW = {
  card: '0 1px 3px rgba(15, 23, 42, 0.03)',
};
